import React, { useContext } from 'react'
import { Grid, Icon, Label, Menu } from 'semantic-ui-react'
import EntityFactory from './cellEntity'
import { ResourceUrlsPopup } from './columnComponents'
import ConfirmationModal from '../../../../../../components/confirmationModal'
import ReportUtils from '../../../../../../utils/reportUtils'
import { CompanyAuthContext } from '../../../../../../App'
import { ChangeLogModal, ReportChangeDescription } from '../../../../../../components/admin/changeLog'
import Alert from '../../../../../../utils/alert'
import { INVALID } from "../../../../../../constnats/generalConstants"
import CollectionUtils from "../../../../../../utils/collections"
import { MetadataField, ReportField, ReportFillingType, SrcFieldValue } from '../../../../../../constnats/reportConstants'
import { getGetPeriod } from '../../../../../../utils/reportResourceUtil'
import ObjCheck from '../../../../../../utils/objCheck'
import Utils from '../../../../../../utils/descriptor/descriptorUtils'
import { ReportChangeConfirmationModalModal } from './reportChangeConfirmationModal'
import { ConfigProps } from '../../../../../../components/financialTables/configuration/constants'
import { DescriptorProps } from '../../../../../../constnats/descriptor'
import DescriptorType from '../../../../../../utils/descriptor/descriptorType'
import CloneUtils from '../../../../../../utils/cloneUtils'
import ColumnTable, { getIsReportReviewed } from './columnReportTable'
import { SchemaNames } from '../../../../../../constnats/schemaConstants';
import { BranchSettingContext } from '../../../../../../contexts/branchSettingsContext';
import { SUPPORTED_DATA } from '../../../stores/peersReportsStore/constants';
class LabelsClipboard {
    static SS_KEY = "labelsClipboard"

    static write(labels) {
        sessionStorage.setItem(LabelsClipboard.SS_KEY, JSON.stringify(labels))
    }

    static read() {
        return JSON.parse(sessionStorage.getItem(LabelsClipboard.SS_KEY))
    }
}

function getRiskyDynamicFieldsChanges(entities) {
    const changes = []
    let isNewReport = true
    for (const entity of entities) {
        if (entity.dynamicField === true) {
            let oldData = entity.getOriginalData()
            if (ObjCheck.isNullUndefinedOrEmpty(oldData)) {
                oldData = ""
            } else {
                isNewReport = false
            }

            let newData = entity.getData()
            if (ObjCheck.isNullUndefinedOrEmpty(newData)) {
                newData = ""
            }

            if (oldData !== newData) {
                changes.push({
                    label: entity.getDescriptor()[DescriptorProps.LABEL],
                    old: entity.getOriginalData(),
                    new: entity.getData()
                })
            }
        }
    }

    return isNewReport ? [] : changes
}

class ColumnInternal extends React.Component {

    constructor(props) {
        super(props);
        this.entryFry = new EntityFactory((descriptorChange, entity, prevData) =>
            this.updateEntries(descriptorChange, entity, prevData),
            () => this.props.reportedAsLabelValidationEnabled)
        this.realTimeEntries = this.entryFry.create(this.props.descriptors, this.props.report)

        this.state = this.getInitialState()

        this.save = this.save.bind(this)
        this.disableEditMode = this.disableEditMode.bind(this)
        this.delete = this.delete.bind(this)
    }

    getInitialState() {
        return {
            editMode: this.props.isNew && !this.props.readOnly,
            /**
             * previous version of copying the realtime entries is brought back 
             * due to a bug where notes are not being saved when they are applied
             * before this we made a change using the deep copy util which lead to the 
             * problem described above
             */
            entries: this.realTimeEntries.slice(),
            modal: <></>,
            updatedOn: this.props.report[ReportField.UPDATED_ON],
            dirty: false,
            hasPendingChanges: this.hasPendingChanges(),
            reportSource: this.props.report[ReportField.SRC],
        }
    }

    hasPendingChanges() {
        let hasPendingChange = false

        if (!this.isCalculatedReport()) {
            const changeListener = (descriptorChange, entity) => {
                if (descriptorChange === true) {
                    if (entity.getData() === "-" &&
                        ObjCheck.isNullUndefinedOrEmpty(this.props.report[ReportField.DYNAMIC_FIELDS][entity.descriptorId()])) {
                        //TODO Find more elegant approach
                    } else {
                        hasPendingChange = true
                    }
                }
            }

            /**
             * TODO remove object cloning once sure that the report is not modified in the EntryFactory. Assume it is not but needs to be confirmed.
             */
            const dryRunEntries = new EntityFactory(changeListener)
                .create(this.props.descriptors, JSON.parse(JSON.stringify(this.props.report)))

            for (const entity of dryRunEntries) {
                entity.refresh()
                // TODO More elegant way
                if (entity.valid() === INVALID) {
                    hasPendingChange = true
                }
                if (hasPendingChange === true) {
                    break
                }
            }
        }

        return hasPendingChange
    }

    isCalculatedReport() {
        return this.props.report[ReportField.SRC] === SrcFieldValue.CALCULATED
    }

    componentDidUpdate(prevProps) {
        if ((prevProps.report.hash !== this.props.report.hash && !this.state.editMode)
            || this.props.report[ReportField.UPDATED_ON] !== this.state.updatedOn) {
            this.reset()
        }
    }

    onReportScaleChange(newScale) {
        // TODO This causes many rerenders. Do it at once
        this.state.entries.filter(e =>
            DescriptorType.isNumber(e.getDescriptor()) &&
            (e.getScalable() || newScale === "0"))
            .forEach(e => e.setFieldInputScale(parseInt(newScale), true))
    }

    onReportSourceChange(entity, prevData) {
        const newSource = entity.getData()
        this.setState({ reportSource: newSource })
        this.state.entries.forEach(e => {
            const shouldPrefillSource = newSource === SrcFieldValue.MIXED && e.getData() && e.dynamicField
            if(shouldPrefillSource) {
                e.setSource(prevData)
            } else {
                e.setSource(null)
            }
        })
    }

    reset() {
        this.entryFry = new EntityFactory((descriptorChange, entity, prevData) =>
            this.updateEntries(descriptorChange, entity, prevData),
            () => this.props.reportedAsLabelValidationEnabled)
        this.realTimeEntries = this.entryFry.create(this.props.descriptors, this.props.report)
        this.setState(this.getInitialState())
    }

    updateEntries(descriptorChange, entity, prevData) {
        if (entity.descriptorId() === DescriptorProps.INPUT_SCALE) {
            this.onReportScaleChange(entity.getData())
        } else if (entity.descriptorId() === ReportField.SRC) {
            this.onReportSourceChange(entity, prevData)
        }
        if (descriptorChange === true) {
            this.setDirty(true)
        }

        this.setState({ entries: this.realTimeEntries })
    }

    enableEditMode() {
        if (!this.isCalculatedReport() && !this.props.readOnly) {
            this.setState({ editMode: true })
            //TODO wrap the entities in a structure an execute a single refresh
            this.state.entries.forEach(e => e.refresh())
        }
    }

    disableEditMode() {
        this.setState({ editMode: false })
        this.setDirty(false)
        this.reset()
    }

    setDirty(dirty) {
        this.setState({ dirty: dirty })
        this.props.setDirty(dirty)
    }

    save({onDiscard = () => {}, onSaved = () => {}}) {
        const entries = this.state.entries
        if (entries.some(e => e.valid() === INVALID)) {
            Alert.warn("The report that you are trying to save was not saved because it contains invalid data." +
                " Please fix it and try again.", "N/A", false)
            return
        }

        const save = () => {
            this.props.save(
                ReportUtils.cellEntitiesToReport(entries, this.props.report),
                () => { this.disableEditMode(); onSaved(); }
            )
        }

        const changes = getRiskyDynamicFieldsChanges(entries)

        if (changes.length > 0) {
            this.openConfirmChangesModal(changes, save, () => {
                this.closeModal();
                onDiscard()
            })
        } else {
            save()
        }
    }

    delete() {
        this.openConfirmationModal("Are you sure that you want to delete this report?", () => {
            this.props.delete(this.props.report.id, () => this.disableEditMode())
        })
    }

    copyLabels() {
        LabelsClipboard.write(this.state.entries.map(e => {
            return { id: e.descriptorId(), label: e.getMetadata()[MetadataField.REPORTED_AS_LABEL] }
        }))
        Alert.success("Copied")
    }

    pasteLabels() {
        const labels = LabelsClipboard.read()

        if (Array.isArray(labels) && labels.length > 1) {
            const labelsMap = CollectionUtils.arrToMap(labels, e => e.id)
            this.state.entries.forEach(e => {
                const mapEntity = labelsMap[e.descriptorId()]
                const labelToCopy = mapEntity ? mapEntity.label : null
                if (labelToCopy !== null) {
                    const newMetadata = Object.assign({}, e.getMetadata())
                    newMetadata[MetadataField.REPORTED_AS_LABEL] = ObjCheck.isNullOrUndefined(labelToCopy) ? "" : labelToCopy
                    e.setMetadata(newMetadata)
                }
            })
        } else {
            Alert.warn("No labels in the clipboard content.")
        }
    }

    openChangeLogModal() {
        const flatDescriptors = Utils.flatDescriptors(this.props.descriptors)
        this.openModal(<ChangeLogModal
            entityId={this.props.report.id}
            onCancel={() => this.closeModal()}
            descriptionCompType={ReportChangeDescription}
            flatDescriptors={flatDescriptors}
        />
        )
    }

    openConfirmationModal(msg, onConfirm) {
        this.openModal(<ConfirmationModal
            msg={msg}
            onCancel={() => this.closeModal()}
            onConfirm={() => {
                onConfirm()
                this.closeModal()
            }} />
        )
    }

    openConfirmChangesModal(changes, onConfirm, onCancel) {
        this.openModal(
            <ReportChangeConfirmationModalModal
                {...{ changes }}
                onConfirm={() => {
                    onConfirm()
                    this.closeModal()
                }}
                onCancel={onCancel} />
        )
    }

    openModal(modal) {
        this.setState({ modal })
    }

    closeModal() {
        this.setState({ modal: <></> })
    }

    columnLabels() {
        const props = ReportUtils.columnLabelProps(this.props.report[ReportField.TYPE],
            this.isCalculatedReport())
        return props !== null ?
            <Label className="columnLabel" color={props.color} size="mini" floating>{props.label}</Label> : <></>
    }

    options() {
        const { report, schemaName, readOnly, openCopyDataModal, isNew } = this.props
        let options = null
        if (this.state.editMode === true) {
            options = <>
                <Icon color='blue' size='small'
                    className='cursorPointer' name='save' onClick={this.save} />
                <ResourceUrlsPopup listSpecProvider={() => this.resourceParams()}
                    schemaName={schemaName} allowEdit={true}
                    allowPreview={true} />
                {report.type === ReportFillingType.ORIGINAL_FILLING &&
                    <Icon color='grey' size='small' className='cursorPointer'
                        name='copy' onClick={() => {
                            openCopyDataModal(ReportUtils
                                .cellEntitiesToReport(this.state.entries, report))
                        }} />}
                {!isNew && <Icon color='grey' size='small'
                    className='cursorPointer' name='cancel' onClick={() => this.disableEditMode()} />}
                <Icon color='red' size='small'
                    className='cursorPointer' name='trash' onClick={this.delete} />
            </>
        } else if (!this.isCalculatedReport()) {
            options = (
                <>
                    <ResourceUrlsPopup listSpecProvider={() => this.resourceParams()}
                        schemaName={schemaName} allowEdit={true}
                        allowPreview={true} />
                    {!readOnly &&
                        report.type === ReportFillingType.ORIGINAL_FILLING &&
                        <Icon color='grey' size='small'
                            className='cursorPointer' name='copy'
                            onClick={() => openCopyDataModal(report)} />}
                    <Icon color='grey' size='small'
                        className='cursorPointer' name='history'
                        onClick={() => this.openChangeLogModal()} />
                </>
            )
        }

        return options
    }

    columnClass() {
        let clazz = this.state.editMode === true ? "editColumn" : ""
        if (this.state.dirty) {
            clazz = clazz + " changedData"
        } else if (this.state.hasPendingChanges) {
            clazz = clazz + " pendingChanges"
        }

        return clazz
    }

    resourceParams() {
        const entities = this.state.entries
        //TODO Refactor
        const year = entities.find(e => e.descriptorId() === ReportField.YEAR).getData()
        const quoter = entities.find(e => e.descriptorId() === ReportField.PERIOD).getData()
        const type = entities.find(e => e.descriptorId() === ReportField.TYPE).getData()
        const latestFiling = type === ReportFillingType.LATEST_FILLING

        return {
            companyId: this.props.companyId,
            year: latestFiling ? Number(year) + 1 : year,
            quoter: getGetPeriod(quoter),
            excludeOriginalOnly: latestFiling
        }
    }

    /**
     * @returns {string} returns the additional class names based on the advanced settings
     */
    getAdditionalColumnClasses() {
        const advancedTableCfg = this.props.advancedTableCfg
        const hasPeriod = !!this.props.report.period;

        const columnBackgroundColorClass = `${hasPeriod ? advancedTableCfg[ConfigProps.PERIOD_CLASSES][this.props.report.period[0]] : ""}`
        const columnNoVerticalsClass = `${advancedTableCfg[ConfigProps.VERTICALS] ? "" : "noVerticals"}`

        return `${columnBackgroundColorClass} ${columnNoVerticalsClass}`;
    }

    render() {
        const { editMode, modal, entries, reportSource } = this.state
        const { report, advancedTableCfg, highlightedRows, filterCfg, saveChanges } = this.props
        return (
            <Grid.Column className={this.columnClass()}>
                {modal}
                <Menu className={`relative _${report.period} ${this.getAdditionalColumnClasses()}`} fluid
                    vertical onDoubleClick={() => this.enableEditMode()} >
                    {this.columnLabels()}
                    <ColumnTable  {...{
                        entries, editMode, highlightedRows, report, reportSource,
                        advancedTableCfg, filterCfg, readOnly:this.props.readOnly
                    }} saveEntries={(onSaved) => this.save({onDiscard:this.disableEditMode, onSaved})} />
                </Menu>
                <div className='reportOptions'>{this.options()}</div>
            </Grid.Column>)
    }
}

ColumnInternal.contextType = CompanyAuthContext;

function Column(props) {
    const branchSettings = useContext(BranchSettingContext)
    const reportedAsLabelValidationEnabled =
        branchSettings.supportedData.includes(SUPPORTED_DATA.REPORTED_AS_LABELS) &&
        !getIsReportReviewed(props.report)

    return <ColumnInternal {...props} reportedAsLabelValidationEnabled={reportedAsLabelValidationEnabled} />
}

export default Column
